export const extractContractNumber = (payload: any): string | undefined => {
  if (!payload) return undefined;

  const sources = [
    payload,
    payload?.vehicle,
    payload?.volkstotal,
    payload?.volksTotal,
    payload?.VolksTotal,
  ].filter(Boolean);

  for (const source of sources) {
    const candidates = [
      source?.contractNumber,
      source?.contractnumber,
      source?.contract,
    ].filter((value): value is string => typeof value === "string" && value.trim() !== "");

    if (candidates.length > 0) {
      return candidates[0];
    }
  }

  return undefined;
};

const sanitizeModalityValue = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;

  const normalized = value.trim();
  if (!normalized) return undefined;

  const withoutVolkstotal = normalized
    .replace(/volks?\s*\|?\s*total/gi, "")
    .replace(/contrato/gi, "")
    .replace(/plano/gi, "")
    .replace(/plan/gi, "")
    .replace(/:/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const base = withoutVolkstotal || normalized;
  const uppercased = base.toUpperCase();

  return uppercased || undefined;
};

export const extractContractModality = (payload: any): string | undefined => {
  if (!payload) return undefined;

  const sources = [
    payload,
    payload?.vehicle,
    payload?.volkstotal,
    payload?.volksTotal,
    payload?.VolksTotal,
    payload?.volks_total,
  ].filter(Boolean);

  for (const source of sources) {
    const candidates = [
      source?.contractModality,
      source?.modality,
      source?.modalityName,
      source?.plan,
      source?.planName,
      source?.volksTotalPlan,
      source?.planType,
    ];

    if (source === payload) {
      candidates.push(payload?.volksTotalPlan);
    }

    for (const candidate of candidates) {
      const sanitized = sanitizeModalityValue(candidate);
      if (sanitized) {
        return sanitized;
      }
    }
  }

  return undefined;
};
